var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.supportsClusteredMarkers
        ? _c(
            "v-marker-cluster",
            {
              ref: "markerClusterRef",
              attrs: { options: _vm.markersClusterOptions }
            },
            _vm._l(_vm.localMarkers, function(marker, index) {
              return _c(
                "div",
                { key: index + "-marker" },
                [
                  _vm.show(index, true)
                    ? _c(
                        "l-marker",
                        {
                          attrs: {
                            draggable: _vm.markerIsDraggable,
                            "lat-lng": marker.position,
                            icon: marker.icon
                          },
                          on: {
                            click: function($event) {
                              return _vm.markerClicked(index, marker, $event)
                            },
                            move: _vm.markerMoved
                          }
                        },
                        [
                          _vm.showMarkerPopup
                            ? _c("l-popup", [
                                _c(
                                  "div",
                                  {
                                    ref: "markerPopupContainer" + index,
                                    refInFor: true
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(marker.label) +
                                        "\n            "
                                    ),
                                    _c("div", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "1px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.markerIsRemovable
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              outline: "",
                                              small: "",
                                              fab: "",
                                              title: _vm.$t(
                                                "mapView.removePlace"
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.removePlace(index)
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.directIsAvailable(index)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              outline: "",
                                              small: "",
                                              fab: "",
                                              title: _vm.$t(
                                                "mapView.toggleDirect"
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.markAsDirectFromHere(
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: marker.place.direct
                                                    ? "primary"
                                                    : "dark"
                                                }
                                              },
                                              [_vm._v("settings_ethernet")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.localMarkers, function(marker, index) {
        return _c(
          "div",
          { key: index + "-marker" },
          [
            _vm.show(index, false)
              ? _c(
                  "l-marker",
                  {
                    attrs: {
                      draggable: _vm.markerIsDraggable,
                      "lat-lng": marker.position,
                      icon: marker.icon
                    },
                    on: {
                      click: function($event) {
                        return _vm.markerClicked(index, marker, $event)
                      },
                      move: _vm.markerMoved
                    }
                  },
                  [
                    _vm.showMarkerPopup
                      ? _c("l-popup", [
                          _c(
                            "div",
                            {
                              ref: "markerPopupContainer" + index,
                              refInFor: true
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(marker.label) +
                                  "\n          "
                              ),
                              _c("div", {
                                staticStyle: { width: "100%", height: "1px" }
                              }),
                              _vm._v(" "),
                              _vm.markerIsRemovable
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        outline: "",
                                        small: "",
                                        fab: "",
                                        title: _vm.$t("mapView.removePlace")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removePlace(index)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.directIsAvailable(index)
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        outline: "",
                                        small: "",
                                        fab: "",
                                        title: _vm.$t("mapView.toggleDirect")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.markAsDirectFromHere(index)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: marker.place.direct
                                              ? "primary"
                                              : "dark"
                                          }
                                        },
                                        [_vm._v("settings_ethernet")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ded97ce0", { render: render, staticRenderFns: staticRenderFns })
  }
}